import React, { useEffect, useState } from 'react'
import { MerchoidSalesDashboardView } from './MerchoidSalesDashboardView'
import axios from 'axios'

export const MerchoidSalesDashboard = () => {
    const [data, setData] = useState([])
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [isoCountryCodes, setIsoCountryCodes] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [avgMargin, setAvgMargin] = useState(0)

    useEffect(() => {
        // Fetch iso country codes first
        axios.get(process.env.REACT_APP_HOST + 'api/fixedData/isoCountryCodes')
            .then((res) => {
                setIsoCountryCodes(res.data);
            })
            .catch((error) => {
                console.error('Error fetching iso country codes:', error);
            });
    }, []);
    
    useEffect(() => {
        // Make sure isoCountryCodes is loaded
        if (isoCountryCodes.length === 0) return;
    
        axios.post(process.env.REACT_APP_HOST + 'api/merchoidSales/fetch', {
            params: {
                startDate: startDate,
                endDate: endDate
            }
        }).then((res) => {
            res.data.forEach((order) => {
                order.notes = addNotesToOrder(order);
            });
            setData(res.data);
            setAvgMargin(calculateAvgMargin(res.data));
            setLoaded(true);
        })
        .catch((error) => {
            console.error('Error fetching sales data:', error);
        });
    }, [startDate, endDate, isoCountryCodes]);
    

    const calculateAvgMargin = (orders) => {
        let totalCosts = 0
        let totalSales = 0
        orders.forEach((order) => {
            totalCosts += parseFloat(order.costPrice) + parseFloat(order.packagingCost) + parseFloat(order.shippingCost) + parseFloat(order.bubbleWrapCost) + parseFloat(order.transactionFee)
            totalSales += order.sellingPriceGbp
        })
        const totalProfit = totalSales - totalCosts
        const avgMargin = totalProfit / totalSales
        console.log({ totalCosts }, { totalSales }, { totalProfit }, { avgMargin })
        return avgMargin
    }

    const addNotesToOrder = (order) => {
        console.log('fire', order)
        if (order.sellingPrice === 0) {
            return 'REPLACEMENT ORDER'
        } else if (
            
            (order.margin < 0.3 && order.shippingCountry === 'GB') ||
            (order.margin < 0.36 && order.shippingCountry === 'US') || // target margins
            (order.margin < 0.32 && order.shippingCountry === 'AU') || // target margins
            (order.margin < 0.36 && order.shippingCountry === 'CA') || // target margins
            (order.margin < 0.30 && isoCountryCodes.eu.includes(order.shippingCountry.toUpperCase())) ||
            (order.margin < 0.36 && isoCountryCodes.row.includes(order.shippingCountry) && !['ca', 'au', 'CA', 'AU'].includes(order.shippingCountry))
        ) {
            if (order.manufacturerId === '582') {
                return 'AAA'
            } else {
                if (order.originalPrice === 0) {
                    return 'PROBLEM'
                } else {
                    return 'DISCOUNTED'
                }

            }
        } else {
            return
        }
    }

    return <MerchoidSalesDashboardView
        data={data}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        isoCountryCodes={isoCountryCodes}
        loaded={loaded}
        avgMargin={avgMargin}
    />
}